import React, { FC } from 'react'

import { IconNeedHelpProps } from './IconNeedHelp.types'
import * as Styled from './styles/IconNeedHelp.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNeedHelp: FC<IconNeedHelpProps> = ({
  size = nonThemeableRules.defaultSize as number as IconNeedHelpProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconNeedHelpProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M153.61 152.34c-.53-.24-12.53-5.76-17-22a77.36 77.36 0 1 0-29.49 20.6c8.88 7.76 20 9.77 31.53 9.77 4.54 0 9.15-.31 13.72-.7a4 4 0 0 0 1.27-7.65zm-42.81-8.9a4 4 0 0 0-4.53-.81 69.15 69.15 0 1 1 22.82-16l.11.11a4 4 0 0 0-.88 3.51 44.8 44.8 0 0 0 12.29 22.4c-11.55.27-22.1-1.38-29.81-9.22z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconNeedHelp
